import React from "react";
import Header from "../Header";
import Footer from "../Footer";

const Privacy = () => {
  return (
    <div>
      <Header position={true} />
      <div className="my-36">
        <div className="w-full items-center flex justify-center ">
          <div className="w-full px-10 md:w-1/2  flex flex-col gap-10">
            <h2 className="text-[#FBC93ECC] text-4xl md:text-6xl font-bold">
              Privacy Policy
            </h2>
            <h3 className="text-3xl md:text-5xl">
              Teific Technology Pvt. Ltd. Privacy Policy
            </h3>
            <div className="flex flex-col gap-10">
              <div className="flex flex-col gap-4">
                <h3 className="text-[#FBC93ECC] font-bold text-3xl">
                  WHAT DO WE DO WITH YOUR INFORMATION?
                </h3>
                <p>
                  <span className="text-[#FBC93ECC] font-bold  text-lg">
                    Personal Information Collection:{" "}
                  </span>
                  When you engage with a service or purchase a product from
                  Teific Technology Pvt. Ltd., we collect the personal
                  information you provide, such as your name, address, and email
                  address. This information is essential for us to fulfill your
                  requests and provide tailored services.
                  <br /> <br />
                  <span className="text-[#FBC93ECC] font-bold  text-lg">
                    {" "}
                    Automatic Information Collection:{" "}
                  </span>
                  Automatic Information Collection: As you navigate through our
                  website, we automatically receive your computer’s internet
                  protocol (IP) address to help us learn about your browser and
                  operating system, enhancing your user experience and site
                  functionality.
                  <br /> <br />
                  <span className="text-[#FBC93ECC] font-bold  text-lg">
                    Use of Information:{" "}
                  </span>
                  Use of Information: By providing us with your personal
                  information, you consent to our using it to complete your
                  transactions and to communicate with you for customer service
                  and promotional purposes, using various communication channels
                  such as email, SMS, or other messaging technologies.
                </p>
              </div>
            </div>

            <div className="flex flex-col gap-10">
              <div className="flex flex-col gap-4">
                <h3 className="text-[#FBC93ECC] font-bold text-3xl">CONSENT</h3>
                <p>
                  <span className="text-[#FBC93ECC] font-bold  text-lg">
                    How Do We Obtain Your Consent?{" "}
                  </span>
                  When you provide us with personal information to complete a
                  transaction, confirm your credit card, place an order, or
                  return a purchase, we imply your consent to our collecting it
                  and using it for that specific reason only.
                  <br /> <br />
                  <span className="text-[#FBC93ECC] font-bold  text-lg">
                    {" "}
                    Secondary Consent:{" "}
                  </span>
                  If we require your personal information for a secondary
                  reason, like marketing, we will directly ask for your
                  expressed consent, or provide you with an opportunity to
                  decline.
                  <br /> <br />
                  <span className="text-[#FBC93ECC] font-bold  text-lg">
                    Withdrawal of Consent:{" "}
                  </span>
                  You may withdraw your consent for us to contact you or for the
                  continued collection, use, or disclosure of your information
                  at any time by contacting us at [support @teific.com] or
                  mailing us at: Teific Technology Pvt. Ltd., 71-A, II RM BLOCK,
                  RAJENDRA NAGAR, SEC 2, GHAZIABAD, Uttar Pradesh, India.
                </p>
              </div>
            </div>

            <div className="flex flex-col gap-10">
              <div className="flex flex-col gap-4">
                <h3 className="text-[#FBC93ECC] font-bold text-3xl">
                  DISCLOSURE
                </h3>
                <p>
                  We may disclose your personal information if we are required
                  by law to do so or if you violate our Terms of Service.
                </p>
              </div>
            </div>

            <div className="flex flex-col gap-10">
              <div className="flex flex-col gap-4">
                <h3 className="text-[#FBC93ECC] font-bold text-3xl">PAYMENT</h3>
                <p>
                  <span className="text-[#FBC93ECC] font-bold  text-lg">
                    Payment Security:{" "}
                  </span>
                  If you choose a direct payment gateway to complete your
                  purchase, Teific Technology Pvt. Ltd. encrypts your credit
                  card data. It adheres to the standards set by the PCI-DSS as
                  managed by the PCI Security Standards Council, which is a
                  joint effort of brands like Visa, MasterCard, American
                  Express, and Discover.
                  <br /> <br />
                  <span className="text-[#FBC93ECC] font-bold  text-lg">
                    {" "}
                    Data Retention:
                  </span>
                  Your purchase transaction data is only stored for as long as
                  necessary to complete your transaction and is then deleted.
                </p>
              </div>
            </div>

            <div className="flex flex-col gap-10">
              <div className="flex flex-col gap-4">
                <h3 className="text-[#FBC93ECC] font-bold text-3xl">
                  THIRD-PARTY SERVICES
                </h3>
                <p>
                  <span className="text-[#FBC93ECC] font-bold  text-lg">
                    Extent of Use:{" "}
                  </span>
                  Our third-party providers will only collect, use, and disclose
                  your information to the extent necessary to perform the
                  services they provide to us.
                  <br /> <br />
                  <span className="text-[#FBC93ECC] font-bold  text-lg">
                    {" "}
                    Provider Policies:{" "}
                  </span>
                  However, certain providers, such as payment gateways and other
                  payment transaction processors, have their own privacy
                  policies. We recommend that you read these policies before
                  proceeding with a transaction that involves their services.
                  <br /> <br />
                  <span className="text-[#FBC93ECC] font-bold  text-lg">
                  International Transfer: {" "}
                  </span>
                  Your information may become subject to the laws of the jurisdiction(s) in which that service provider or its facilities are located.
                </p>
              </div>

            </div>

            <div className="flex flex-col gap-10">
  {/* Section 6 - Security */}
  <div className="flex flex-col gap-4">
    <h3 className="text-[#FBC93ECC] font-bold text-3xl"> SECURITY</h3>
    <p>
      To protect your personal information, Teific Technology Pvt. Ltd. takes
      reasonable precautions and follows industry best practices, including
      encryption and physical security measures to prevent loss, misuse,
      unauthorized access, disclosure, alteration, or destruction.
    </p>
  </div>

  {/* Section 7 - Age of Consent */}
  <div className="flex flex-col gap-4">
    <h3 className="text-[#FBC93ECC] font-bold text-3xl">AGE OF CONSENT</h3>
    <p>
      By using this site, you represent that you are at least the age of
      majority in your jurisdiction, and you have given us your consent to allow
      any of your minor dependents to use this site.
    </p>
  </div>

  {/* Section 8 - Changes to This Privacy Policy */}
  <div className="flex flex-col gap-4">
    <h3 className="text-[#FBC93ECC] font-bold text-3xl"> CHANGES TO THIS PRIVACY POLICY</h3>
    <p>
      We reserve the right to modify this policy at any time, so please review
      it frequently. Changes and clarifications will take effect immediately
      upon their posting on the website. We will notify you of significant
      changes by updating the date at the top of this policy.
      <br /> <br />
      <span className="text-[#FBC93ECC] font-bold text-lg">Contact Information:</span> 
      If you would like to access, correct, amend, or delete any personal
      information we have about you, register a complaint, or simply want more
      information, contact our Privacy Compliance Officer at{" "}
      <a href="mailto:support@teific.com" className="text-blue-500">
        support@teific.com
      </a>{" "}
      or by mail at Teific Technology Pvt. Ltd.
    </p>
  </div>
</div>

          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Privacy;
